module.exports = "<div [ngClass]=\"{'swiper-container': config?.containerModifierClass === undefined }\">\n  <ng-content></ng-content>\n</div>"